import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'nl2br'})

export class NewLineToBreak implements PipeTransform {
	transform(value: string): string {
      return value.replace(/\r|\n/g, '<br/>');
   }
}